import { Card, Typography } from "antd";
import { FrownOutlined } from "@ant-design/icons";
import React from "react";
import { red } from "@ant-design/colors";
import clsx from "clsx";

type ErrorMessageProps = {
  title?: string;
  message?: string;
  fullScreen?: boolean;
  icon?: React.ReactNode;
  className?: string;
};

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  title = "Oops! Something went wrong",
  message = "Please try again or contact support.",
  fullScreen = false,
  icon,
  className = "",
}) => {
  return (
    <div
      className={clsx(
        "flex items-center justify-center",
        fullScreen ? "h-screen" : "h-full",
        className,
      )}
    >
      <Card className="p-8 rounded-2xl shadow-lg text-center">
        <div className="flex flex-col items-center">
          {icon || (
            <FrownOutlined
              style={{ color: red.primary }}
              className="text-4xl mb-1 animate-pulse"
            />
          )}
          <Typography.Title level={4} className="mb-2">
            {title}
          </Typography.Title>
          <Typography.Text className="mb-4">{message}</Typography.Text>
        </div>
      </Card>
    </div>
  );
};

export default ErrorMessage;
